<template>
  <div id="success-page">
    <div class="adaptive-column-content">
      <div class="final-block-flex">
        <div class="text">
          <div class="title">Отлично,<br/>{{ titleText }}</div>
          <div class="subtitle" v-html="subtitleText"></div>
        </div>
        <div class="image">
          <div class="text">
            Приятного<br/>аппетита
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SuccessPage',
    computed: {
      type () {
        return this.$route.params.type
      },
      titleText () {
        return this.type === 'order' ? 'Ваш заказ оформлен' : 'Ваша заявка получена'
      },
      subtitleText () {
        return this.type === 'order'
          ? 'Если мы не позвоним Вам в течение 10&nbsp;минут, пожалуйста свяжитесь с нами.'
          : 'Если мы не позвоним Вам в течение дня, пожалуйста свяжитесь с нами.'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index/SuccessPage.vue